// 3rd party
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

// components
import { ComponentsModule } from 'app/shared/components/components.module';
import { LoginComponent } from 'app/login/login-default/login.component';
import { LoginFeedComponent } from 'app/login/login-feed/login-feed.component';
import { LoginFeedCardComponent } from 'app/login/login-feed/login-feed-card/login-feed-card.component';
import { ServerNotResponding } from './shared/server-not-responding/server-not-responding.component';

// modules
import { LayoutModule } from 'app/shared/layout/layout.module';
import { MaterialModule } from 'app/shared/material/material.module';

// services
import { ConnectService } from './shared/connect.service';

@NgModule({
  imports: [
    CommonModule,
    MaterialModule,
    LayoutModule,
    TranslateModule,
    ComponentsModule,
    FormsModule,
    ReactiveFormsModule
  ],
  exports: [
    LoginComponent,
    LoginFeedComponent,
  ],
  declarations: [
    LoginComponent,
    LoginFeedComponent,
    LoginFeedCardComponent,
    ServerNotResponding,
  ],
  providers: [
    ConnectService,
  ]
})
export class LoginModule { }



// WEBPACK FOOTER //
// ./src/app/login/login.module.ts